import * as React from 'react';
import {Divider, DividerProps} from '@mui/material';
import {styled} from '@mui/material/styles';

export type Props = DividerProps & {
	color?: string;
	opacity?: string;
	width?: string;
	marginTop?: string;
	marginBottom?: string;
	marginLeft?: string;
	marginRight?: string;
};

export const EnhancedDivider = (props: Props) =>
{
	const width = props.width ? props.width : "97%";
	const color = props.color ? props.color : '#ffffff';
	const opacity = props.opacity ? props.opacity : 'B3';
	const EnhancedDividerWrapper = styled(Divider)`
      border-color: ${color}${opacity} !important;
      border-width: 0.5px !important;
      width: ${width};
      margin-bottom: ${props.marginBottom ? props.marginBottom : "0.5em"} !important;
      margin-top: ${props.marginTop ? props.marginTop : "0.5em"} !important;
      margin-left: ${props.marginLeft ? props.marginLeft : "0"} !important;
      margin-right: ${props.marginRight ? props.marginRight : "0"} !important;
	`;
	const render = () =>
	{
		const outgoingProps: DividerProps = {
			orientation: props.orientation ? props.orientation : 'horizontal',
			variant: props.variant ? props.variant : 'fullWidth',
		};
		const returnValue = <EnhancedDividerWrapper {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
